var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-empty"},[_c('van-empty',{staticClass:"custom-image",attrs:{"image":_vm.image,"description":_vm.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }